// Components
const ClientHeader = () => import(/* webpackPrefetch: true, webpackChunkName: "client-header" */ '@/app/views/client-view/_shared/client-header/client-header.vue');
const TheFooter = () => import(/* webpackPrefetch: true, webpackChunkName: "the-footer" */ '@/app/views/main-view/_shared/the-footer/the-footer.vue');
const DogPurchasePublicPage = () => import(/* webpackPrefetch: true, webpackChunkName: "dog-purchase-public-page" */ '@/app/views/client-view/dog-purchase-public-page/components/dog-purchase-public-page/dog-purchase-public-page.vue');

// Mixins
import { googleTagManagerMixins } from '@/app/mixins/utils/google-tag-manager-mixins';

export default {
    name: 'DogPurchasePublic',
    mixins: [ googleTagManagerMixins ],
    components: {
        ClientHeader,
        TheFooter,
        DogPurchasePublicPage,
    },
    computed: {
        isNativeApp() {
			return this.$store.getters.getIsNativeApp;
		},
    },
    data() {
        return {
            hasLatitudePay: false,
            showMainLogo: true
		}
    },
    created() {},
    methods: {
        btnYes(){
            this.hasLatitudePay = !this.hasLatitudePay
        },
    },
}